import { render, staticRenderFns } from "./NsTooltip.vue?vue&type=template&id=cbe6d2e8&scoped=true&"
import script from "./NsTooltip.vue?vue&type=script&lang=js&"
export * from "./NsTooltip.vue?vue&type=script&lang=js&"
import style0 from "./NsTooltip.vue?vue&type=style&index=0&id=cbe6d2e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe6d2e8",
  null
  
)

export default component.exports